import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Table, Spinner, Alert } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

// Auth get json helper
async function authGetJson(url) {
  const r = await authFetch(url);

  if (r && typeof r === "object" && !("ok" in r) && !("json" in r)) return r;

  if (r?.ok) return await r.json();

  const msg = r?.text ? await r.text() : "Request failed";
  throw new Error(msg);
}

export default function StocCurentPickerModal({
  show,
  onHide,
  onPick,
  initialQuery = "",
  gestiuneId,
}) {
  const [q, setQ] = useState(initialQuery);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [items, setItems] = useState([]);

  const fetchData = async (query = q) => {
    if (!gestiuneId) {
      setItems([]);
      setErr("Te rog selectează o gestiune mai întâi.");
      return;
    }

    setBusy(true);
    setErr("");
    try {
      const url = `/stock/stocin/search?gestiune_id=${gestiuneId}&q=${encodeURIComponent((query || "").trim())}`;
      const data = await authGetJson(url);
      const list = Array.isArray(data) ? data : (data?.items || data || []);
      setItems(list);
    } catch (e) {
      setErr(String(e?.message || e));
      setItems([]);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (!show) return;

    setQ(initialQuery || "");
    setErr("");
    setItems([]);
    fetchData(initialQuery || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, gestiuneId]);

  const pick = (item) => {
    if (!item) return;

    const code = item.cod ?? "";
    const name = item.denumire ?? "";
    const label = `${code ? code + " • " : ""}${name}`.trim();

    onPick?.({
      id: item.bxpart_id,
      label,
      raw: item,
    });

    onHide?.();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Alege produs din stoc</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {err && <Alert variant="danger">{err}</Alert>}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            fetchData(q);
          }}
        >
          <div className="d-flex gap-2">
            <Form.Control
              autoFocus
              placeholder="Caută în stoc (Cod sau Denumire, Enter)..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
            <Button type="submit" disabled={busy}>
              Caută
            </Button>
          </div>
        </Form>

        <div className="mt-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
          {busy ? (
            <div className="d-flex align-items-center gap-2">
              <Spinner size="sm" />
              <span>Se încarcă stocul...</span>
            </div>
          ) : (
            <Table hover size="sm" className="mb-0">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>Cod</th>
                  <th>Denumire</th>
                  <th style={{ width: 100 }} className="text-end">Stoc Disp.</th>
                  <th style={{ width: 100 }} className="text-end">Pret Unitar</th>
                  <th style={{ width: 80 }} className="text-center">Lot ID</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr
                    key={`${item.bxstocin_id}-${item.bxpart_id}-${idx}`}
                    role="button"
                    onClick={() => pick(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{item.cod}</td>
                    <td>{item.denumire}</td>
                    <td className="text-end font-monospace fw-bold text-primary">
                      {Number(item.cantitate || 0).toFixed(3)}
                    </td>
                    <td className="text-end font-monospace">
                      {Number(item.pret_magazie || 0).toFixed(2)}
                    </td>
                    <td className="text-center text-muted">
                      #{item.bxstocin_id}
                    </td>
                  </tr>
                ))}

                {items.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text-muted text-center py-3">
                      Nu există produse în stoc pentru gestiunea selectată.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
